import { Injectable, signal } from '@angular/core';

/** The header's "parent › title" for a page the navigation menu does not list (e.g. one matter). */
export interface PageTitle {
  parent: string;
  title: string;
}

/**
 * P269 (P266 G9): a page that is not in the menu sets its own header title once it knows it (the matter page sets the
 * matter reference) and clears it when it is left. The layout shows it instead of the menu-derived title.
 */
@Injectable({ providedIn: 'root' })
export class PageTitleService {
  readonly current = signal<PageTitle | null>(null);

  set(title: PageTitle): void {
    this.current.set(title);
  }

  clear(): void {
    this.current.set(null);
  }
}
